import useSWR from "swr";
import { endpointsBilling } from "lib/actions/endpoints/endpointsBilling";
import { fetcher } from "lib/actions/fetcher";
import { WorkspaceSubscriptionStatus } from "lib/types/subscriptions/WorkspaceSubscriptionStatus";
import { WorkspaceSubscriptionTierWithPrice } from "lib/types/workspaces/WorkspaceSubscriptionTierWithPrice";

export const useWorkspaceSubscription = (workspaceId: number) => {
  const {
    data: subscriptionStatus,
    error: statusError,
    mutate: statusMutate,
  } = useSWR<WorkspaceSubscriptionStatus>(
    workspaceId && endpointsBilling.workspaceSubscriptionStatus(workspaceId),
    fetcher,
  );
  const {
    data: subscriptionTier,
    error: tierError,
    mutate: tierMutate,
  } = useSWR<WorkspaceSubscriptionTierWithPrice>(
    workspaceId && endpointsBilling.subscriptionTierDetails(workspaceId),
    fetcher,
  );

  return {
    subscriptionTier,
    subscriptionStatus,
    isSubscriptionLoading:
      (!subscriptionStatus && !statusError) ||
      (!subscriptionTier && !tierError),
    hasSubscriptionError: !!statusError || !!tierError,
    async mutateSubscription() {
      const [status, tier] = await Promise.all([statusMutate(), tierMutate()]);
      return { status, tier };
    },
  };
};
